import * as React from "react";
import type { SVGProps } from "react";
const SvgIconBroom = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <g clipPath="url(#clip0_6129_18711)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.98.82q-.38.13-.53.43L8.22 7l-2.2 5.7c-.03.06-.07.07-.3.12-.34.07-.58.15-.92.31-.5.24-1.03.64-1.39 1.05-.3.36-.6.87-.77 1.32-.11.33-1.85 6.71-1.85 6.81 0 .4.27.75.64.85.12.03.87.04 5.8.04 6.2 0 5.8 0 6.02-.13.1-.07.27-.25.32-.37.14-.28.1-.63-.1-.9-.04-.04-.43-.35-.88-.69-1.05-.78-1.23-.95-1.5-1.43q-.47-.82-.35-1.8c.1-.87.1-1.3-.01-1.82-.3-1.35-1.23-2.48-2.49-3l-.34-.13-.1-.05 2.11-5.5c1.3-3.38 2.12-5.53 2.14-5.62.06-.37-.15-.74-.5-.9-.16-.07-.42-.1-.57-.05m2.35 12.75c-.22.07-.45.29-.54.51-.06.18-.06.44 0 .62.07.17.25.37.43.46l.14.07h5.23l.14-.07c.17-.08.34-.25.42-.42.05-.12.06-.17.06-.35 0-.19 0-.24-.06-.36-.08-.17-.25-.34-.42-.42l-.14-.06H16c-2.05-.01-2.6 0-2.68.02m-7 .9c-.47.06-.79.18-1.13.42-.2.13-.5.42-.63.6-.25.36-.27.41-1.05 3.29l-.74 2.69h7.52l-.15-.15-.31-.4q-1.01-1.46-.8-3.27c.03-.22.04-.53.04-.74 0-.32 0-.4-.06-.6-.12-.41-.29-.72-.58-1.04-.39-.43-.95-.73-1.53-.8-.2-.02-.45-.03-.57 0m9.41 3.07c-.2.06-.43.25-.52.44-.08.14-.11.39-.08.55.06.26.24.5.48.62l.14.06h2.55c1.97.01 2.58 0 2.67-.01q.24-.07.4-.26c.4-.42.26-1.1-.26-1.35l-.13-.06h-2.6zm1.7 3.97c-.35.05-.65.34-.7.7-.03.16 0 .36.06.5s.26.34.43.42l.13.07h2.52q2.53 0 2.65-.02c.66-.13.9-.96.42-1.43q-.2-.2-.49-.25c-.19-.03-4.83-.02-5.02 0"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6129_18711">
        <rect width={24} height={24} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgIconBroom;
